import React from 'react';

import { useNavigate, useParams, useScreenLink } from '@gogame/screens';

import { financialResultsLink } from 'scenes/FinancialResults/navigation';
import { ioLink } from 'scenes/IO/navigation';
import { regsStatsLink } from 'scenes/RegsStats/navigation';
import { trackerLink } from 'scenes/Trackers/Tracker/navigation';

export const ACTION_OPEN_SUBSCRIPTIONS = 'Subscriptions';

export const SubscriptionsRedirect = () => {
  const navigate = useNavigate();
  const { screen } = useParams();
  const link =
    {
      tracker: trackerLink,
      'financial-results': financialResultsLink,
      io: ioLink,
      'regs-stats': regsStatsLink,
    }[screen] || null;

  const to = useScreenLink({ link });

  React.useEffect(() => {
    navigate(to, {
      state: { action: ACTION_OPEN_SUBSCRIPTIONS },
    });
  }, []);

  return null;
};
